import saveCustomer from './saveCustomer'
import getListCustomers from './getListCustomers'
import getCustomerById from './getCustomerById'
import createCustomer from './createCustomer'

export default {saveCustomer, getListCustomers, getCustomerById, createCustomer}
